// extracted by mini-css-extract-plugin
export default {"ModeratorInvitationListItem":"bcf_a bhf_a bhf_r bhf_j","ModeratorInvitationListItem__left":"bcf_b bhf_a bhf_j","ModeratorInvitationListItem__note":"bcf_c bhf_fm"};